module.exports = __webpack_public_path__ + "static/media/map1.9c4638a3.webp";